// Keeps staged character radio inputs and their tile data attributes in sync.
export function setCharacterBoolean(character, attribute, value) {
  const input = character.querySelector(`[data-character-screen-attribute="${attribute}"][value="${String(value)}"]`);
  if (input) input.checked = true;

  const dataAttribute = attribute === 'active_turn' ? 'characterActive' : 'characterHidden';
  character.dataset[dataAttribute] = String(value);
}

export function syncCharacterScreenState(character, force = false) {
  if (!force && character.dataset.characterScreenState === 'offscreen') return;
  character.dataset.characterScreenState = character.dataset.characterHidden === 'true' ? 'hidden' : 'visible';
}
